import Cookies from 'js-cookie';
import { KioskCookies } from '../../../../helpers/Cookies';
import { useCallback } from 'react';
import { AppointmentDispatchTypes, useAppointmentDispatch } from '../../../Appointment/appointment';
import { useNavigate } from 'react-router';
import { AppRoutePaths } from '../../../../helpers/Routes';
import type { SavedSessionFinishHook } from './SavedSessionFinish.types';

/**
 * Hook exposing functions for ending or fully clearing the current saved
 * session. Returns `finishSession` (removes the SavedSession cookie only) and
 * `clearSession` (clears appointment state, removes the cookie, and navigates
 * back to the Appointment route).
 */
export const useSavedSessionFinish: SavedSessionFinishHook = () => {
    const appointmentDispatch = useAppointmentDispatch();
    const navigate = useNavigate();

    return {
        finishSession: useCallback(async () => {
            Cookies.remove(KioskCookies.SavedSession);
        }, []),
        clearSession: useCallback(async () => {
            appointmentDispatch({ type: AppointmentDispatchTypes.Remove });
            Cookies.remove(KioskCookies.SavedSession);
            navigate(AppRoutePaths.Appointment);
        }, [appointmentDispatch, navigate]),
    };
};